export const FADED_FITOGRAM_BLUE = '#93c5fb';
export const LIGHTER_BLUE = '#EDF6FE';
export const LIGHT_BLUE = '#EBEFF5';
export const DEFAULT_TEXT_COLOR = '#333333';
export const WHITE = '#FFFFFF';
export const TRANSPARENT_WHITE = '#ffffffc4';
export const DARK_WHITE = '#E9E9E9';
export const DRAWER_INACTIVE_SELECTION = '#E7EAEE';
export const CHARCOAL_GREY = '#383E41';
export const LIGHT_GREY = '#F5F5FB';
export const NORMAL_GREY = '#BDBDBD';
export const DARK_GREY = '#838383';
export const GRAY_USC = '#8C9BB0';
export const GRAY_TABLE_TITLE = '#383E41B3';
export const TABLE_HEAD_BORDER = '#191E247F';
export const DARKER_GREY = '#939393';
export const DARKEST_GREY = '#4a4d51';
export const GREY = '#8F8F8F';
export const PLACEHOLDER = '#999999';
export const LABEL_COLOR = '#7B8794';
export const PLAIN_GREY = '#ADADAD';
export const GREEN = '#199D12';
export const GREEN_2 = '#6CBC88';
export const LIGHT_GREEN = '#E3F3E7';
export const BLACK = '#000000';
export const ERROR = '#fdecea';
export const TEXT_ERROR = '#611a15';
export const ICON_ERROR = '#f44336';
export const FADED_ICON_ERROR = '#ee595919';
export const WARNING = '#fff4e5';
export const TEXT_WARNING = '#663c00';
export const ICON_WARING = '#ff9800';
export const INFO = '#e9f4fd';
export const TEXT_INFO = '#0d3c61';
export const ICON_INFO = '#2196f3';
export const DEACTIVATED_GREY = '#FBFBFE';
export const BADGE_NEW = '#F8A200';
export const NOTE_RED = '#ED2F2F';
export const RED_USC = '#F94848';
export const LIGHT_RED = '#FCECEC';
export const FADED_GREY = '#D0D0D080';
export const RED_DOT = '#B70000';
export const DISABLED = '#00000042';
export const LIGHT_GRAY_BACKGROUND = '#F0F0F070';
export const LIGHT_GRAY = '#EAEAEA80';
export const MIDDLE_GRAY = '#738A9E';
export const PINK = '#F2DFDF';
export const LIGHT_GREY_1 = '#B3B3B3';
export const TRANSPARENT = 'transparent';
export const BACKGROUND_PRIMARY = '#21272F';
export const BACKGROUND_ACTIVE = '#2E3742';
export const BACKGROUND_HOVER = '#4D5561';
export const ICON_SECONDARY = '#A3AFC0';

// BLUES
export const PRIMARY_BLUE = '#337BE2';
export const FITOGRAM_BLUE = '#0084F8';
export const FITOGRAM_BLUE_EXTRA_LIGHT = '#E5F2FE';
export const FITOGRAM_BLUE_LIGHT = '#007AFF';
export const FITOGRAM_BLUE_DARK_1 = '#007deb';
export const FITOGRAM_BLUE_DARK_2 = '#0072d6';
export const FITOGRAM_BLUE_DARK_3 = '#0067c2';
export const FITOGRAM_BLUE_FADED_8 = '#0084f81a';
export const FITOGRAM_BLUE_FADED_9 = '#0084F811';
export const FITOGRAM_BLUE_FADED_10 = '#F5F7FA';
export const FITOGRAM_BLUE_TINTED = '#337BE2';

// GRAYS
export const GRAY_LIGHT = '#7676801f';
export const GRAY_LIGHT_2 = '#191E24';
export const GRAY_BACKGROUND = '#F9F9F9';
export const GRAY_BACKGROUND_2 = '#F2F2F2';
export const GRAY_DARK_SHADE_1 = '#F8FAFD';
export const GRAY_DARK_SHADE_2 = '#F1F4F9';
export const GRAY_DARK_USC = '#ACACAC';
export const GRAY_ACTIVE_SELECTION = '#F6F9FB';
export const GRAY_DISABLED = '#CDD6DE';

// SHADOWS
export const SHADOW_CONTAINER = '#D7D7D780';
export const SHADOW_LEVEL_2 = '#9A9A9AD6';
export const SHADOW_LEVEL_3 = '#7d7d7d4d';
export const SHADOW_DARK = '#191E243D';
export const SHADOW_BLACK_LIGHT = '#0000000A';
export const SHADOW_BLACK_MEDIUM = '#0000001F';

// BORDERS AND DIVIDERS
export const VERTICAL_SEPARATOR = '#E1E1E1';
export const VERTICAL_SEPARATOR_1 = '#F6F9FB';
export const BORDER_COLOR = '#E7E7E7';
export const BORDER_COLOR_SHADE_2 = '#C6c6c6';
export const BORDER_BLACK_LIGHT = SHADOW_BLACK_LIGHT;
export const BORDER_DIVIDER = '#3B4654';

// ITEM SPECIFIC BACKGROUND COLORS THAT MIGHT CHANGE FOR DARK MODE
export const ACTION_TOOLBAR_BACKGROUND = WHITE;
export const BACKGROUND_COLOR = WHITE;
export const DESKTOP_BACKGROUND_COLOR = GRAY_DARK_SHADE_1;
export const TEXT_SUBHEADER = '#646566';
export const TEXT_PRIMARY_ACTION = PRIMARY_BLUE;
export const TEXT_SECONDARY_ACTION = PLAIN_GREY;

// CHIP Colors
export const CHIP_COLOR_ORANGE = '#F47B20';
export const CHIP_BACKGROUND_ORANGE = '#FDE5D2';
export const CHIP_COLOR_GREEN = '#2EBA88';
export const CHIP_BACKGROUND_GREEN = '#DEF4EC';
export const CHIP_COLOR_RED = '#E25061';
export const CHIP_BACKGROUND_RED = '#FAE3E6';
export const CHIP_BACKGROUND_GRAY = '#E7EAEE';

// Image Specific
export const IMAGE_GRADIENT = 'linear-gradient(0deg, #0606060a, #0606060a)';

export const OPACITY_TRANSPARENT = '00';
export const OPACITY_LIGHTEST = '1A';
export const OPACITY_LIGHT = '4D';
export const OPACITY_MEDIUM = '7F';
export const OPACITY_DARK = 'B3';
export const OPACITY_FULL = 'FF';

export const combinedColor = (color: string, opacity: string) => `${color}${opacity}`;
